import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'


import {
    Menu,
    MenuItem,
    withStyles,
    Button,
    ListItemText,
    ListItem,
    List,
    Avatar,
    DialogTitle,
    Dialog,
    Tooltip
} from '@material-ui/core'

class OrganisationSelector extends React.Component{


    state={
        waitedForLoad:false,
    }


    handleClick = (organisationId) =>{
        const {selected} = this.props
        if(organisationId && organisationId != null){
            selected(organisationId)
        }
       
    }

    componentWillMount(){
        if(!this.state.waitedForLoad){
            setTimeout(function(){ this.setState({ waitedForLoad:true})}.bind(this), 5000);    
        } 
    }
    
    render(){        
        const {organisations,selectedOrganisation,open,classes,selected,...other} = this.props
        let currentOrganisation = null
        let image = ""

        if(organisations && selectedOrganisation){
           
            if(organisations && selectedOrganisation){
                organisations.forEach(element => {
                    if( element.id == selectedOrganisation){
                        currentOrganisation = element
                        image = currentOrganisation.avatarUrl
                    }
                })
            }
        }

        return(
            ( 
            this.state.waitedForLoad ?
            open ?
                <Dialog open={open}  aria-labelledby="simple-dialog-title" {...other}>
                <DialogTitle style={{backgroundColor:"#fc824e"}} id="simple-dialog-title"><div style={{color:"#fff"}} >Select Current Organisation</div></DialogTitle>
                <div>
                <List component="nav">
                {organisations&&organisations.length>0?organisations.map(organisation => (
                    <ListItem
                        button onClick={() => this.handleClick(organisation.id)} key={organisation.id}
                        >
                        {organisation?
                            organisation.avatarUrl?
                                <Avatar style={{height:"unset"}} src={organisation.avatarUrl}/>:<Avatar>{organisation.name?organisation.name.charAt(0):"U"}</Avatar>
                            :null
                        }
                
                        <ListItemText
                            primary={organisation?organisation.name:"Undefined Organisation"}
                            secondary={organisation?organisation.description:""}
                        />
                    </ListItem>
                ))
                :
                    <ListItem
                            button onClick={() => this.handleClick(null)} key={0}
                            >
                            <Avatar>X</Avatar>
                            <ListItemText
                                primary={"You are part no of organisation"}
                                secondary={"Please ask administrator To add you to an organisation"}
                            />
                    </ListItem>
                }
                </List>          
                </div>
                </Dialog>
            :
                    <div>
                    <Tooltip title="Change current organisations" placement="bottom"  classes={{ tooltip: classes.lightTooltip }}>
                     <List>
                         <ListItem  button onClick={() => this.handleClick(currentOrganisation?currentOrganisation.id:null)}
                         key={currentOrganisation?currentOrganisation:0}>
                        {
                            organisations&&organisations.length>0&&currentOrganisation?
                            
                            <span>
                                    {currentOrganisation.avatarUrl?
                                         <img style={styles.image} src={image}/>
                                        :<span style={{color:"#fff",backgroundColor:"#bdbdbd",padding:19,borderRadius:"70%",paddingTop: 15,
                                        paddingBottom: 15,display:"inline",position:"relative",top:8}}><span>{currentOrganisation.name?currentOrganisation.name.charAt(0):"U"}</span></span>
                                    }
                             <span style={{marginTop:20}}>
                                    <span style={{marginTop:30,marginLeft:15}}>{currentOrganisation.name?currentOrganisation.name:"Add Organisation name"}</span><br />    
                                    <span style={{marginLeft:60,fontSize:13,color:"#a8a8a8"}}>{currentOrganisation.description?currentOrganisation.description:"Add description text"}</span>          
                                </span> 
                            </span>
                        :
                            <span>
                            <span style={{color:"#fff",backgroundColor:"#bdbdbd",padding:19,borderRadius:"70%",paddingTop: 15,
                                        paddingBottom: 15,display:"inline",position:"relative",top:8}}><span>U</span></span>
    
                                     <span style={{marginTop:30,marginLeft:15}}>No organisation selected</span><br />    
                                    <span style={{marginLeft:60,fontSize:13,color:"#a8a8a8"}}>please select an organisation</span>          
                               
                            </span>
                            
                        }
                        <KeyboardArrowDownIcon style={{fontSize:21,marginTop:-22}}/>
                        </ListItem>
                        </List>
                        </Tooltip>          
                 </div>
                :
                <div style={{marginRight:150,marginTop:20}}>
                    <LoadingSpinner size={20} thickness={4}></LoadingSpinner>
                </div>
            )
        )
    }
}

const styles={
    AvatarContainer:{
        marginTop:60,
        marginRight:10,
        width: 20,
        height: 20,
    },
    image:{
        borderRadius:"70%",
        width: 45,
        height: 45,
        display:"inline",
        marginTop:-25,
        position:"relative",
        top:25
    },
    lightTooltip: {
        background: "white",
        fontSize: 12,
        color:"rgba(0, 0, 0, 0.87)",
        boxShadow:"0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)"
      },
  }


export default withStyles(styles)(OrganisationSelector)


// WEBPACK FOOTER //
// ./src/components/OrganisationSelector/OrganisationSelector.jsx